import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityRole", "accessibilityState", "accessibilityTraits", "accessible", "forwardLabel", "onAccessibilityTap", "onLayout", "onMoveShouldSetResponder", "onPress", "onPressIn", "onPressOut", "onResponderGrant", "onResponderMove", "onResponderReject", "onResponderRelease", "onResponderTerminate", "onStartShouldSetResponder", "testID", "accessibilityLabel", "tag", "htmlFor", "style", "onRef"],
  _excluded2 = ["lineHeight", "transform"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { prefixStyle } from '@lada/prefix';
import usePropDeprecationWarning from '@bubble-ui/hook-use-prop-deprecation-warning';
import { defaultStyles } from './defaultStyles';
import { styleTransformArrayToText } from './styleTransformArrayToText';
var View = _ref => {
  var {
      // extract native only props and throw away
      /* eslint-disable @typescript-eslint/no-unused-vars */
      accessibilityRole,
      accessibilityState,
      accessibilityTraits,
      accessible,
      forwardLabel,
      onAccessibilityTap,
      onLayout,
      onMoveShouldSetResponder,
      onPress,
      onPressIn,
      onPressOut,
      onResponderGrant,
      onResponderMove,
      onResponderReject,
      onResponderRelease,
      onResponderTerminate,
      onStartShouldSetResponder,
      testID,
      /* eslint-enable @typescript-eslint/no-unused-vars */
      // named props
      accessibilityLabel,
      tag,
      htmlFor,
      style,
      onRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropDeprecationWarning({
    componentName: 'View',
    propName: 'forwardLabel',
    shouldWarn: forwardLabel !== undefined,
    removalDate: 'v6.0.0'
  });
  usePropDeprecationWarning({
    componentName: 'View',
    propName: 'onPress',
    shouldWarn: onPress !== undefined,
    removalDate: 'v6.0.0'
  });
  usePropDeprecationWarning({
    componentName: 'View',
    propName: 'onPressIn',
    shouldWarn: onPressIn !== undefined,
    removalDate: 'v6.0.0'
  });
  usePropDeprecationWarning({
    componentName: 'View',
    propName: 'onPressOut',
    shouldWarn: onPressOut !== undefined,
    removalDate: 'v6.0.0'
  });
  var mergedStyles = React.useMemo(() => {
    var _ref2 = style || {},
      {
        // @ts-expect-error
        lineHeight,
        transform
      } = _ref2,
      restOfStyles = _objectWithoutProperties(_ref2, _excluded2);
    return prefixStyle(_objectSpread(_objectSpread(_objectSpread({}, defaultStyles), restOfStyles), {}, {
      lineHeight: lineHeight && "".concat(lineHeight, "px"),
      transform: transform && styleTransformArrayToText(transform)
    }));
  }, [style]);
  switch (tag) {
    case 'label':
      {
        return /*#__PURE__*/React.createElement("label", {
          htmlFor: htmlFor
        }, /*#__PURE__*/React.createElement("div", _extends({}, props, {
          "aria-label": accessibilityLabel,
          ref: onRef,
          style: mergedStyles
        })));
      }
    default:
      {
        return /*#__PURE__*/React.createElement("div", _extends({}, props, {
          "aria-label": accessibilityLabel,
          ref: onRef,
          style: mergedStyles
        }));
      }
  }
};
View.displayName = 'View';
export default View;
export var ViewStyles = defaultStyles;
//# sourceMappingURL=index.js.map